import React, { useEffect, useState } from "react";
import { SelectArrayInput, required } from "react-admin";
import { AlertTypes } from "../defaults/Alerts";

const EventTypeSelector = (props) => {
  const [eventTypes, setEventTypes] = useState([]);
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    const fetchEventTypes = async () => {
      try {
        const response = await AlertTypes();
        const eventTypes = response.map((alertType) => ({
          id: alertType.id,
          name: alertType.event_type,
        }));
        setAlerts(props.record.AlertTypes.map((alertType) => alertType.id));
        setEventTypes(eventTypes);
      } catch (error) {
        console.error(error);
      }
    };
    fetchEventTypes();
  }, [props.record.AlertTypes]);

  props.record.event_types = alerts;
  return (
    <SelectArrayInput
      record={props.record}
      fullWidth
      label="Alert Types"
      source="event_types"
      initialvalue={alerts}
      validate={[required()]}
      choices={eventTypes}
    />
  );
};

export default EventTypeSelector;
